import React from 'react';
import { PropTypes } from 'prop-types';

const FileIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25281 3.46803C6.81726 -0.355162 11.5959 -1.12882 14.649 1.70504C17.702 4.5389 17.8643 12.3602 14.649 15.8089C11.4337 19.2576 4.023 18.1512 1.49955 15.8089C-1.0239 13.4667 -0.311651 7.29121 3.25281 3.46803Z"
      // eslint-disable-next-line react/destructuring-assignment
      fill={props.color}
      {...props}
    />
    <g>
      <path
        d="M11.3516 5.15442V6.75176H12.9489L11.3516 5.15442Z"
        fill="white"
      />
      <path
        d="M11.088 7.27914C10.9424 7.27914 10.8244 7.16109 10.8244 7.01547V5H6.94129C6.36519 5 5.89648 5.4687 5.89648 6.04481V12.9552C5.89648 13.5313 6.36519 14 6.94129 14H12.0587C12.6348 14 13.1035 13.5313 13.1035 12.9552V7.27914H11.088ZM7.30511 6.52128H7.66623V6.16016C7.66623 6.01454 7.78429 5.89648 7.9299 5.89648C8.07552 5.89648 8.19358 6.01454 8.19358 6.16016V6.52128H8.5547C8.70032 6.52128 8.81837 6.63934 8.81837 6.78495C8.81837 6.93057 8.70032 7.04862 8.5547 7.04862H8.19358V7.40975C8.19358 7.55537 8.07552 7.67342 7.9299 7.67342C7.78429 7.67342 7.66623 7.55537 7.66623 7.40975V7.04862H7.30511C7.15949 7.04862 7.04144 6.93057 7.04144 6.78495C7.04144 6.63934 7.15949 6.52128 7.30511 6.52128ZM11.7082 12.8652H7.30511C7.15949 12.8652 7.04144 12.7472 7.04144 12.6016C7.04144 12.456 7.15949 12.3379 7.30511 12.3379H11.7082C11.8538 12.3379 11.9719 12.456 11.9719 12.6016C11.9719 12.7472 11.8538 12.8652 11.7082 12.8652ZM7.04144 11.6348C7.04144 11.4892 7.15949 11.3711 7.30511 11.3711H10.79C10.9356 11.3711 11.0536 11.4892 11.0536 11.6348C11.0536 11.7804 10.9356 11.8984 10.79 11.8984H7.30511C7.15949 11.8984 7.04144 11.7804 7.04144 11.6348ZM11.7082 10.9765H7.30511C7.15949 10.9765 7.04144 10.8584 7.04144 10.7128C7.04144 10.5672 7.15949 10.4491 7.30511 10.4491H11.7082C11.8538 10.4491 11.9719 10.5672 11.9719 10.7128C11.9719 10.8584 11.8538 10.9765 11.7082 10.9765ZM7.04144 9.78116C7.04144 9.63554 7.15949 9.51749 7.30511 9.51749H11.1809C11.3265 9.51749 11.4445 9.63554 11.4445 9.78116C11.4445 9.92678 11.3265 10.0448 11.1809 10.0448H7.30511C7.15949 10.0448 7.04144 9.92678 7.04144 9.78116ZM11.7082 9.10527H7.30511C7.15949 9.10527 7.04144 8.98721 7.04144 8.84159C7.04144 8.69598 7.15949 8.57792 7.30511 8.57792H11.7082C11.8538 8.57792 11.9719 8.69598 11.9719 8.84159C11.9719 8.98721 11.8538 9.10527 11.7082 9.10527Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="9" height="9" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

FileIcon.propTypes = {
  color: PropTypes.string,
};

FileIcon.defaultProps = {
  color: '#FB9318',
};

export default FileIcon;
